<template>
  <CToaster
    v-if="getToasters.length"
    :class="getToasterPosition === 'center' ? 'center' : ''"
    :position="getToasterPosition !== 'center' ? getToasterPosition : null"
  >
    <CToast
      v-for="toast in getToasters"
      :key="'toast' + toast.id"
      :class="['toast', toast.modal ? 'modal-toast' : toast.class]"
      :show="true"
      @close="removeToastBasedOnId(toast.id)"
    >
      <!-- Modal toast -->
      <template v-if="toast.modal">
        <div
          class="modal-toast-header d-flex justify-content-between align-items-center h-10 rounded"
          :class="toast.class"
          style="min-height: 2rem"
        >
          <div class="d-inline-flex">
            <i
              v-if="toast.headerIcon"
              :class="`fa-solid ${toast.headerIcon} fs-20 mr-3`"
            ></i>
            <strong class="me-auto">{{ toast?.header || "" }}</strong>
          </div>

          <!-- <CButton
            v-if="!toast.closeButton"
            close
            aria-label="Close"
            class="bg-transparent border-0 p-0 shadow-none hover-bg-none"
            @click="removeToastBasedOnId(toast.id)"
            style="background-color: transparent !important;"
          >
            <i class="fa-solid fa-xmark text-white fs-20"></i>
          </CButton> -->
        </div>
        <div class="modal-toast-body">
          {{ toast?.message || "" }}
        </div>
        <div class="modal-toast-footer d-flex justify-content-end gap-2 mt-2">
          <CButton
            v-for="(btn, index) in toast.buttons"
            :key="index"
            style="
              background-color: var(--primary) !important;
              border-color: var(--primary) !important;
              color: white !important;
            "
            :size="btn.size || 'sm'"
            @click="
              btn.action ? btn.action(toast.id) : removeToastBasedOnId(toast.id)
            "
          >
            {{ btn.label }}
          </CButton>
        </div>
      </template>

      <!-- Regular toast -->
      <template v-else>
        <div>{{ toast.message }}</div>
      </template>
    </CToast>
  </CToaster>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["getToasters", "getToasterPosition"]),
  },
  methods: {
    ...mapActions(["removeToastBasedOnId"]),
  },
};
</script>

<style scoped>
/* Centered toast */
.center {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  max-width: 500px;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

/* Modal toast specific styles */
.modal-toast {
  min-width: 300px;
  max-width: 500px;
  padding: 0px;
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.modal-toast .toast-body {
  padding: 0 !important;
}

/* Modal toast header */
.modal-toast-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #dee2e6;
  font-weight: 400;
}

/* Modal toast body */
.modal-toast-body {
  padding: 0.5rem;
  font-weight: 500;
}

/* Modal toast footer */
.modal-toast-footer {
  padding: 0.5rem;
}

.fs-20 {
  font-size: 20px;
}

.hover-bg-none:hover,
.hover-bg-none:focus {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
